// extracted by mini-css-extract-plugin
export default {"container":"Login_container__p-+Gw","ver":"Login_ver__hRkPi","placeHolderShimmer":"Login_placeHolderShimmer__0oozl"};